import { useEffect } from 'react';

import useUserStore from '../stores/UserStore';

const useFeaturebase = () => {
  const ORGANIZATION = 'sbccrm';
  const user = useUserStore((state) => state.user);

  useEffect(() => {
    if (user?.email && user?.featurebase_hash) {
      const win = window;
      if (typeof win.Featurebase !== 'function') {
        win.Featurebase = function () {
          // eslint-disable-next-line prefer-rest-params
          (win.Featurebase.q = win.Featurebase.q || []).push(arguments);
        };
      }

      // Initialize Featurebase with user data
      window.Featurebase(
        'identify',
        {
          organization: ORGANIZATION,
          email: user.email,
          name: `${user.first_name} ${user.last_name}`.trim(),
          userId: user._id,
          userHash: user.featurebase_hash,
        },
        (err) => {
          if (err) {
            console.error('Featurebase identification failed:', err);
          } else {
            console.log('User identified with Featurebase');
          }
        }
      );
    }
  }, [user]);
};

export default useFeaturebase;
